import artsBackground from '../assets/images/illustrations/ntee-backgrounds/arts.jpg';
import educationBackground from '../assets/images/illustrations/ntee-backgrounds/education.jpg';
import environmentBackground from '../assets/images/illustrations/ntee-backgrounds/environment-animals.jpg';
import healthBackground from '../assets/images/illustrations/ntee-backgrounds/health.jpg';
import humanServicesBackground from '../assets/images/illustrations/ntee-backgrounds/human-services.jpg';
import internationalBackground from '../assets/images/illustrations/ntee-backgrounds/international-foreign-affairs.jpg';
import memberBackground from '../assets/images/illustrations/ntee-backgrounds/member-benefit.jpg';
import publicBackground from '../assets/images/illustrations/ntee-backgrounds/public-societal-benefit.jpg';
import religionBackground from '../assets/images/illustrations/ntee-backgrounds/religion.jpg';
import unclassifiedBackground from '../assets/images/illustrations/ntee-backgrounds/unclassified-unknown.jpg';

const getCategoryBackground = categoryString => {
  if (categoryString === '' || categoryString === 'Unknown, Unclassified') {
    return unclassifiedBackground;
  }
  if (categoryString === 'Arts, Culture, and Humanities') {
    return artsBackground;
  }
  if (categoryString === 'Education') {
    return educationBackground;
  }
  if (categoryString === 'Environment' || categoryString === 'Animals') {
    return environmentBackground;
  }
  if (categoryString === 'Health') {
    return healthBackground;
  }
  if (categoryString === 'Human Services') {
    return humanServicesBackground;
  }
  if (categoryString === 'International, Foreign Affairs') {
    return internationalBackground;
  }
  if (categoryString === 'Public, Societal Benefit') {
    return publicBackground;
  }
  if (categoryString === 'Religion Related') {
    return religionBackground;
  }
  if (categoryString === 'Mutual/Membership Benefit') {
    return memberBackground;
  }
  if (categoryString === 'Unknown, Unclassified') {
    return unclassifiedBackground;
  }
  return unclassifiedBackground;
};

const charityCategories = [
  'Arts & Culture',
  'Civil Rights',
  'Education',
  'Environment & Animals',
  'Health',
  'Human Services',
  'International Affairs',
  'Religion',
];

export { getCategoryBackground, charityCategories };
